import { toast } from "react-toastify";
import { postDataFromApi, getDataFromApi, putDataFromApi } from "../../../../services/commonServices";
import { onAccountGetApi, onAccountCreateApi, onAccountUpdateApi } from "../../../../services/api";

export const handleGetOnAccountData = async (id, setFormData, setIsOverlayLoaders) => {
    try {
        setIsOverlayLoaders(true);
        // Assuming 'ioa_id' or 'id' is required based on common patterns in this codebase
        let res = await getDataFromApi(onAccountGetApi + "?ioa_id=" + id);

        if (res.data.status === 200) {
            setFormData((prevFormData) => {
                return {
                    0: {
                        ...prevFormData[0],
                        ...res?.data?.data,
                        "ioa_status": res?.data?.data?.ioa_is_closed ? "Closed" : "Open",
                    },
                };
            });
        } else {
            toast.error(res.message || "Failed to fetch on-account data", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    } catch (error) {
        console.error("Error fetching on-account data:", error);
    } finally {
        setIsOverlayLoaders(false);
    }
};

export const handleOnAccountCreateUpdate = async (
    formData,
    handleSubmit,
    setIsOverlayLoader,
    navigate,
    type
) => {
    try {
        setIsOverlayLoader(true)
        let isValidate = handleSubmit();
        if (!isValidate) {
            return false;
        }
        let payloadData = {
            ...formData[0]
        }
        if(type==="post"){
            payloadData.ioa_is_closed = true
        }
        let res
        if (formData[0]?.ioa_id) {
            res = await putDataFromApi(onAccountUpdateApi, payloadData)
        } else {
            res = await postDataFromApi(onAccountCreateApi, payloadData)
        }

        if (res?.data?.status === 200) {
            toast.success(res?.data?.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            navigate("/collections/on-accounts")

        } else {
            toast.error(res.message || "Something went wrong", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }
    finally {
        setIsOverlayLoader(false)
    }
}
